import { getSchemaOwner } from '@preset-engine/ownership/get-schema-owner.js'

export function resolveSchemaOwnerForRemoval(
  cwd: string,
  schemaName: string
): 'core' | 'user' | `preset:${string}` {
  const explicitOwner = getSchemaOwner(cwd, schemaName)
  if (explicitOwner) {
    return explicitOwner
  }

  if (schemaName === 'settings') {
    return 'core'
  }

  return 'user'
}
